import { render, staticRenderFns } from "./Monitors.vue?vue&type=template&id=995ff82c&"
import script from "./Monitors.vue?vue&type=script&lang=js&"
export * from "./Monitors.vue?vue&type=script&lang=js&"
import style0 from "./Monitors.vue?vue&type=style&index=0&id=995ff82c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports